// extracted by mini-css-extract-plugin
export default {"removeButton":"e8444ac7e98b1121ca09a56bc9f92e29","pageTitle":"_400affeaa82c1faad16d0e31ee78eb7e"};